import { DropdownWithoutOptionsProps } from "components/dropdowns/models";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import React from "react";
import { type Theme } from "../models";

const options: Array<{ text: string, value: Theme }> = [{
  text: RESX.EmbedWizard.Light,
  value: "normal"
}, {
  text: RESX.EmbedWizard.Dark,
  value: "dark"
}];

export const getThemeDropdownLabel = (theme: Theme) => {
  const option = options.find(o => o.value === theme);
  return option ? option.text : "";
}

const ThemeDropdown = (props: DropdownWithoutOptionsProps<Theme, Theme>) => {
  const selectedValue = options.find(o => o.value === props.value);

  return <BaseReactSelectDropdown
    options={options}
    value={selectedValue}
    onChange={v => { props.onChange(v.value); }}
    getLabel={o => o.text}
    getValue={o => o.value}
    excludeKeys={[]}
    config={{
      isSearchable: false,
      shouldRenderSelectedValue: true,
      ...props.config,
    }}
  />
};

export default ThemeDropdown;